var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetflix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 67,
    viewBox: "0 0 38 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37473 8.02575L12.8886 40.5821V65.1854C8.35811 65.4005 5.78971 65.6326 1.37473 66.1552V8.02575ZM36.2914 17.3288C36.2634 30.9434 36.2337 45.3763 36.2924 59.6764L24.8052 27.2086V1.50773L36.3184 1.51017C36.3135 6.61313 36.3026 11.906 36.2914 17.3288ZM24.2015 65.1661C16.1775 42.4763 9.81186 24.4856 1.67987 1.50757H13.1083C16.048 9.82334 19.2486 18.8715 22.5373 28.1691C26.9898 40.7567 31.604 53.8015 35.9517 66.1047C35.1973 66.0138 34.1296 65.8917 32.8616 65.7645C30.4474 65.5224 27.2988 65.2615 24.2015 65.1661Z",
    stroke: "#00739E",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetflix);
export default __webpack_public_path__ + "static/media/netflix.252c14556d649548554b9f425615e7b8.svg";
export { ForwardRef as ReactComponent };